export default {
  elb : {
    title : 'Elastic Load Balancer',
    add:'Create Elastic Load Balancer',
    all:'ALL',
    location:'Location',
    noData:'No data found, you can ',
    create:'create an instance',
    navTab : {
      'insM' : 'Instance Management',
      'cerM' : 'Certificate Management',
      'ac' : 'Access Control',
    },
    insList : {
      searchName:'Search ID or Name',
      searchButtonName:'Search',
      columnName : 'Name / ID',
      ipAddress : 'IP Address',
      zone : 'Zone',
      period : 'Validity Period',
      port : 'Port / Health Check / Server Group',
      status : 'Status',
      actions : 'Actions',
      statusList:{
        Running:'Running',
        Disabled:'Disabled',
        Deleting:'Deleting',
        Failed:'Failed',
        Creating:'Creating',
        Disabling:'Disabling',
        Editing:'Editing',
        Enabling:'Enabling',
        Unknown:'Unknown'
      },
      actionsList:{
        'manage':'Manage',
        'renew':'Renew'
      },
      serverType:{
        'virtual':'[virtual]',
        'masterSlave':'[Master-slave]'
      }
    },
    manage:{
      tab:{
        'detail':'Instance Details',
        'listener':'Listener',
        'virtual':'Virtual Server Group',
        'masterSlave':'Primary/secondary Server Group',
      },
      insDetail:{
        'base':'Basic Information',
        'name':'Name',
        'status':'Status',
        'rename':'Rename',
        'renamePage':{
          'sureRename':'Sure to rename',
          'newName':'New Name:',
          'inputTip':'Please enter a new Name here',
          'characters':'Characters',
          'cancel':'Cancel',
          'done':'Done',
        }
      },
      listener:{
        index:{
          listenerName:'Add Listener',
          list:{
            id:'Listener/ID',
            port:'Protocol Port',
            healthStatus:'Health Status',
            group:'Server Group',
            AC:'Access Control',
            ACSwitch:{
              'off':'OFF',
              'on':'ON',
              'config':'Config',
            },
            status:'Status',
            statusList:{
              Running:'Running',
              Disable:'Disable',
              Fail:'Fail',
              Deleting:'Deleting',
              Creating:'Creating',
              Disabling:'Disabling',
              Starting:'Starting',
              Modifying:'Modifying',
            },
            actions:'Actions',
            actionList:{
              'CL':'Configurate Listener',
              'CF':'Configurate Forwarding',
              'MC':'Manage Certificate',
              'MED':'Manage Extended Domain',
              'stop':'Stop',
              'delete':'Delete',
              'start':'Start',
            },
          },
          rename:{
            title:'Rename Listener',
            sure:'Sure to rename:',
            reName:'New Name',
            inputTip:'Please enter a new Name here',
            characters:'Characters',
            cancel:'Cancel',
            done:'Done',
            limit:'Listener name must be 2 to 64 characters',
          },
          accessControl:{
            title:'Configure Access Control',
            switch:'Access Control Switch:',
            switchDesc:'After enabling access control, you can configure the access control policy to allow or prohibit certain specific IP access to load balancing',
            method:'Access Control Method:',
            methodError:'Please Select Access Control Method',
            group:'Select Access Control Policy Group:',
            groupError:'Please Select Access Control Policy Group',
            cancel:'Cancel',
            done:'Done',
            Whitelist:'Whitelist',
            Blacklist:'Blacklist',
            select:'select',
          },
          delete:{
            'title':'Delete Listener',
            'sure':'Sure to delete the selected listener?',
            'cancel':'Cancel',
            'done':'Done',
            'name':'Name:',
          },
          stop:{
            'title':'Stop Listener',
            'sure':'Sure to stop the selected listener?',
            'cancel':'Cancel',
            'done':'Done',
            'name':'Name:',
          },
          extendedDomain:{
            title:'Manage Extended Domain',
            input:'Domain',
            inputError:'Wrong domain name',
            select:'Select Server Certificate',
            add:'Add Extended Domain',
            list:'Extended Domain List',
            cer:'Certificate Name (Damain)',
            cerError:'Please Select Server Certificate',
            status:'Status',
            actions:'Actions',
            cancel:'Cancel',
            delete:'Delete',
            deletePage:{
              title:'Delete Additional Certificate',
              sure:'Sure to delete the additional certificate?',
              cancel:'Cancel',
              delete:'Delete',
            },
            statusList:{
              Running:'Running',
              Stopping:'Stopping',
              Abnormal:'Abnormal',
              Deleting:'Deleting',
              Creating:'Creating',
              Editing:'Editing',
            },
          },
          certificate:{
            title:'Manage Certificate',
            select:'Select Server Certificate:',
            buy:'Purchase Certificate',
            new:'New Server Certificate',
            cancel:'Cancel',
            confirm:'Confirm',
          },
          newCertificate:{
            title:'New Server Certificate',
            list:'Certificate List:',
            listDesc:'If you have not purchased a certificate yet, please apply for a\n' +
              '              certificate in the\n' +
              '              <a  href="/ssl/index/instance" data-v-7927e006=""class="button-text"><span>SSL Certificate</span></a>\n' +
              '              service, or upload a certificate issued by a third party.',
            cancel:'Cancel',
            done:'Done',
            type:'Certificate Type:',
            uploadYi:'Upload a certificate issued by YisuCloud',
            uploadNotYi:'Upload a certificate not issued by YisuCloud',
            name:'Name:',
            nameDesc:'The value contains 1 to 80 letters, digits, hyphens (-), slash (/), periods (.), underscores (_), and asterisks (*).',
            pubkey:'Certificate Public Key',
            pubkeyTip:"<li>\n" +
              "                        The public key certificate contains information such as\n" +
              "                        the public key and signature of the certificate.\n" +
              "                      </li>\n" +
              "                      <li>\n" +
              "                        Load balancing ELB uses certificates in NGINX format,\n" +
              "                        usually with .pem (or .crt or others) as the suffix in\n" +
              "                        the NGNIX format certificate file obtained from the\n" +
              "                        certificate provider.\n" +
              "                      </li>",
            pubkeyView:'<p>\n' +
              '                        The certificate file you obtain from a certificate\n' +
              '                        service provider usually contains your own certificate\n' +
              '                        and the certificate of the intermediate issuing\n' +
              '                        authority, which is usually called a certificate chain.\n' +
              '                        When uploading a certificate, you need to make sure to\n' +
              '                        upload the complete certificate chain. Load balancing\n' +
              '                        ELB is compatible with NGINX format certificate files,\n' +
              '                        and you can directly upload certificates in NGINX\n' +
              '                        format. The usual format is as follows. Note that the\n' +
              '                        green font part is the certificate file identifier and\n' +
              '                        cannot be omitted.\n' +
              '                      </p>\n' +
              '                      <p class="green">-----BEGIN CERTIFICATE-----</p>\n' +
              '                      <p>Server public key certificate (BASE64 encoding)</p>\n' +
              '                      <p class="green">-----END CERTIFICATE-----</p>\n' +
              '                      <p>!!! There mustbe no blank lines in the middle!!!</p>\n' +
              '                      <p class="green">-----BEGIN CERTIFICATE-----</p>\n' +
              '                      <p>\n' +
              '                        Intermediate issuing organization public key certificate\n' +
              '                        (BASE64 encoding)\n' +
              '                      </p>\n' +
              '                      <p class="green">-----END CERTIFICATE-----</p>',
            Nginx:'Compatible with NGINX format.',
            View:'View Sample',
            prikey:'Certificate Private Key',
            priTip:'<li>\n' +
              '                        The private key of the certificate is usually suffixed\n' +
              '                        with key in the certificate file (obtained from the\n' +
              '                        certificate provider in NGINX format).\n' +
              '                      </li>',
            prikeyView:' <p>\n' +
              '                        Load balancing ELB is compatible with NGINX format\n' +
              '                        certificate files, and you can directly upload\n' +
              '                        certificates in NGINX format. The usual format is as\n' +
              '                        follows. Note that the green font part is the\n' +
              '                        certificate file identifier and cannot be omitted.\n' +
              '                      </p>\n' +
              '                      <p class="green">-----BEGIN CERTIFICATE-----</p>\n' +
              '                      <p>Certificate private key (BASE64 encoding)</p>\n' +
              '                      <p class="green">-----END CERTIFICATE-----</p>',
            cerError:'Please choose a certificate',
            nameError:'The name must be 1 to 80 characters',
            pubError:'Please offer the public key',
            priError:'Please offer the private key',
          },
          forwardingRule:{
            title:'Configurate Forwarding Rule',
            desc:' <li>\n' +
              '            * Domain name specification: -Pan-resolution domain name:\n' +
              '            *.test.com, * must be the first character, and in the format of *.\n' +
              '            or *aaa., * cannot be the last. -Standard domain name: www.test.com;\n' +
              '          </li>\n' +
              '          <li>\n' +
              '            * URL specification: the length is limited to 2-80 characters, only\n' +
              '            letters, numbers, \'-\', \'/\', \'.\', \'%\' ,\'?\', \'#\', \'&\' can be used; The\n' +
              '            URL cannot only be /, but it must start with /.\n' +
              '          </li>\n' +
              '          <li>* Please fill in at least one of the domain name and URL</li>',
            domain:'Domain',
            url:'URL',
            group:'Server Group',
            remark:'Remark',
            actions:'Actions',
            delete:'Delete',
            addDomain:'Add A Domain',
            addRule:'Add A Rule',
            add:' Add Forwarding Rule(s)',
            settings:'Forward Rule List',
            status:'Status',
            cancel:'Cancel',
            edit:'Edit',
            select:'(Please Choose)',
            error:{
              domain:'Please enter the domain',
              group:'Please select serverGroup',
              url:'URL Error',
              remark:'Remark Error',
            },
          },
          forwardingRuleEdit:{
            title:'Manage Access Control',
            domain:'Domain:',
            url:'URL:',
            group:'Server Group:',
            remark:'Remark:',
            rule:'Forwarding Rule Advanced Settings:',
            ruleDesc:'Turn on this switch to set the scheduling algorithm, session retention level and health check related settings separately for the forwarding rules; the forwarding strategy is configured separately\n',
            ruleScheduling:'Scheduling Algorithm :',
            wrr:'Weighted Round-Robin (WRR)',
            rr:'Round-Robin (RR)',
            WebSocket:'WebSocket:',
            session:'Session Persistence:',
            sessionDesc:'The tcp protocol maintains the session based on the IP address, and forwards the request of the same IP address to the same back-end cloud server for processing',
            cookieHandling:'Cookie Handling:',
            implant:'Implant Cookie',
            rewrite:'Rewrite Cookie',
            persistenceTimeout:'Persistent Timeout:',
            persistenceTimeoutDesc:'Valid range: 1-3600',
            healthCheckSwitch:'Health Check Switch:',
            sessionName:'Session Name:',
          },
          forwardingRuleDelete:{
            title:'Delete Policy',
            desc:'Caution: It cannot be restored once deleted.',
            tip:'Sure to delete the policy?',
            cancel:'Cancel',
            delete:'Delete',
          },
          addListener:{
            title:'ELB Configuration Wizard',
            first:{
              title:'Protocol & Listener',
              protocol:'Protocol:',
              port:'Listening Port:',
              portDesc:'Range from 1 to 65525',
              setting:'Advanced Settings',
              redirection:'Redirection:',
              redirectionTip:'Used to forward traffic monitored at HTTP:80 to HTTPS:443, so that HTTP protocol is forced to redirect to HTTPS. ',
              webSocket:'WebSocket:',
              Session:'Session Persistence:',
              SessionTip:'The TCP protocol persistents the session based on the IP address, and forwards the request of the same IP address to the same back-end cloud server to process.',
              schedulingAlgorithm:'Scheduling Algorithm:',
              wrr:'Weighted Round-Robin (WRR)',
              wrrTip:'The higher the weight value of the backend server, the higher the number of polls (probability). ',
              rr:'Round-Robin (RR)',
              rrTip:'Distribute external requests to backend server in sequence according to the order of access.',
              requestTimeout:'Request Timeout:',
              s:'s',
              requestTimeoutTip:'While configuring TCP connection times out, load balancer will automatically disconnect after connection idle time exceeds the timeout period. The timeout input range of TCP is 10-900 seconds and of HTTP/HTTPS is 1-180 seconds. ',
              idleTimeout:'Idle Timeout:',
              idleTimeoutTip:'If there is no access request for more than a period of time, the load balancer will temporarily interrupt the current connection until a new connection is re-established when the next request comes.',
              listenerName:'Listener Name:',
              listenerNameDesc:'2-64 Characters',
              targetPort:'Target Port:',
              targetPortTip:'Usually port 80 is used for HTTP and port 443 is used for HTTPS.',
              targetPortDesc:'Please Select',
              cookieHandlingOptions:'Cookie Handling Options:',
              SessionPersistenceTimeout:'Session Persistence Timeout:',
              bandwidthPeak:'Bandwidth Peak',
              accessControl:'Access Control',
              cookieName:'Cookie Name:',
              implantCookie:'Implant Cookie',
              rewriteCookie:'rewriteCookie',
              certificate:'Certificate:',
              newCer:'New Server Certificate',
              buyCer:'Buy a Certificate',
              OFF:'OFF',
              ON:'ON',
              Unlimited:'Unlimited',
            },
            two:{
              title:'Configurate Portb',
              desc:'Please select the type of Configurate Port to which the listening request will be forwarded:',
              Virtual:'Virtual Server Group',
              VirtualTip:'Each load balancing instance can create multiple virtual server groups, which can be associated with monitoring or forwarding rules to realize the function of forwarding different services to different backend servers.',
              Master:'Primary/secondary Server Group',
              MasterTip:'Active and  standby server grooup is a special server group. At the same time, only one of two servers is working. When the health check of the active server shows abnormity, it will automatically switch to the standby server. When the active server returns to normal, it will take over for the standby server.',
              group:'Select Server Group:',
              newVirtual:'Create Vitrual Server Group',
              newMaster:'Create Primary/secondary Server Group',
              select:'Selected Server Group:',
              list:{
                ECSID:'ECS ID',
                Zone:'Zone',
                Status:'Status',
                statuslist:{
                  Creating:'Creating',
                  Installing:'Installing',
                  Starting:'Starting',
                  Running:'Running',
                  Stopped:'Stopped',
                  ExpiringSoon:'Expiring soon',
                  Expired:'Expired',
                  Invalid:'Invalid',
                  Reinstalling:'Reinstalling',
                  ShuttingDown:'Shutting down',
                  PoweredOff:'Powered off',
                  ExpireSoon:'Expire soon',
                  Unknown:'Unknown',
                },
                Port:'Port',
                PortDesc:'Range from 1 to 65535',
                Weight:'Weight',
                WeightDesc:" <ul>\n" +
                  "                                <li>\n" +
                  "                                  The greater the weight, the more requests will\n" +
                  "                                  be forwarded. The default value is 100.\n" +
                  "                                </li>\n" +
                  "                                <li>\n" +
                  "                                  If session persistence is enabled, the requests\n" +
                  "                                  to the back-end server may be uneven.\n" +
                  "                                </li>\n" +
                  "                                <li>\n" +
                  "                                  If the weight is set to 0, the server will not\n" +
                  "                                  accept new requests.\n" +
                  "                                </li>\n" +
                  "                              </ul>",
                Actions:'Actions',
                ActionssList:{
                  remove:'Remove',
                },
                machineType:'Machine Type',
                Master:'Master',
                Slave:'Slave',
              },
            },
            third:{
              title:'Health Check',
              healthCheck:'Health Check:',
              healthCheckTip:'When using HTTP protocol for health check, GET method request is used by default.',
              healthCheckMethod:'Health Check Method:',
              path:'Health Check Path:',
              pathTip:'It is used for the URI of the health check page file, and it is recommended to check the static page.',
              domain:'Health Check Domain (Optional):',
              domainTip:'By default, the intranet IP of each back-end server is used as the domain name.',
              domainDesc:'Only letters, digits, \'-\' and \'.\'can be used.',
              normalStatusCode:'Normal Status Code:',
              check:'Health Check Port:',
              checkDesc:'Range 1-65535',
              checkTip:'The back-end server port is used for checking by default, and it is recommended to leave it blank unless a specific port is specified',
              responce:'Responce Timeout :',
              inspection:'Inspection Interval :',
              health:'Health Threshold:',
              unhealth:'Unhealth Threshold :',
            },
            fourth:{
              title:'Configuration Check',
              protocol:'Protocol & Monitoring',
              ELBProtocol:'ELB Protocol:',
              listeningPort:'Listening Port:',
              schedulingAlgorithm:'Scheduling Algorithm:',
              sessionPersistence:'Session Persistence:',
              accessControl: 'Access Control:',
              bandwidthPeak: 'Bandwidth Peak:',
              requestTimeout:'Request Timeout:',
              healthCheck:'Health Check',
              healthChecked:'Health Check:',
              healthCheckProtoco:'Health Check Protocol:',
              responceTimeout:'Responce Timeout:',
              Inspection:'Inspection Interval:',
              health:'Health Threshold:',
              unhealth:'Unhealth Threshold:',
              configuratePort:'Configurate Port',
            },
            error:{
              protocol:'Please select protocol',
              listenPort:'Listening Port Input Error',
              listenPortExists:'Listening port already exists',
              listenName:'Listening Name Error',
              requestTimeout:'Request Timeout Does Not Match(1-180)',
              targetPort:'Please Select Target Port',
              forwardPortNeed:'The listening port to enable listening forwarding needs to be 80',
              idleTimeout:'Idle Timeout Does Not Match(1-60)',
              cookieHandling:'Please select Cookie Handling',
              persistenceTimeout:'Persistence Timeout Input Error',
              cookieName:'CookieName Error',
              certificate:'Please Select Certificate',
              serverGroup:'Please Select Server Group',
              normalStatus:'Please Select Normal Status Code',
              healthCheckPath:'Please Enter Health Check Path',
              responceTimeout:'Responce Timeout Error',
              inspectionInterval:'Inspection Interval Error',
              healthThreshold:'Health Threshold Error',
              unhealth:'Unhealth Threshold Error',
            },
            Previous:'Previous',
            Next:'Next',
            Cancel:'Cancel',
            Done:'Done',
            Edit:'Edit',
          },
          virtualGroup:{
            addTitle:'Create Virtual Server Group',
            list:{
              name:'Name/ID',
              listen:'Associated Listening',
              Forward:'Associated Listening Forwarding Policy',
              status:'Status',
              actions:'Actions',
              edit:'Edit',
              delete:'Delete',
              domain:'Domain',
              url:'URL',
              statusList:{
                Running:'Running',
                Disable:'Disable',
                Fail:'Fail',
                Deleting:'Deleting',
                Creating:'Creating',
                Modify:'Modify',
              },
            },
            add:{
              title:'Create Virtual Server Group',
              desc:'The current load balancer\'s network type is classical, and the instance type is private. You can add cloud servers of classical or private network types into the virtual server group.',
              name:'Virtual Server Group Name',
              add:'Add',
              cancel:'Cancel',
              save:'Save',
              remove:'Remove',
              actions:'Actions',
            },
            serverList:{
              title:'My Server List',
              one:'Select Server',
              two:'Configurate Port',
              cancel:'Cancel',
              next:'Next',
              previous:'Previous',
              done:'Done',
              statusList:[
                { text: 'Running', value: 4 },
                { text: 'Stopped', value: 6 },
                { text: 'Expired', value: 7 },
              ],
            },
            editName:{
              title:'Rename',
              sure:'Sure to rename',
              name:'New Name:',
              tip:'Please enter a new Name here',
              desc:'6-64 Characters',
              cancel:'Cancel',
              done:'Done',
            },
            edit:{
              title:'Edit Virtual Server Group',
            },
            delete:{
              title:'Delete Virtual Server Group',
              tip:'Sure to delete the virtual server group?',
              name:'Name:',
              cancel:'Cancel',
              delete:'Delete',
            },
            error:{
              port:'Please fill in the port',
              weight:'Please fill in the weight',
            },
          },
          mSGroup:{
            host:'host',
            backup:'backup',
            addTitle:'Create Primary/secondary Server Group',
            list:{
              name:'Name/ID',
              listen:'Associated Listening',
              Forward:'Associated Listening Forwarding Policy',
              status:'Status',
              actions:'Actions',
              view:'View',
              delete:'Delete',
              domain:'Domain',
              url:'URL',
              statusList:{
                Running:'Running',
                Disable:'Disable',
                Fail:'Fail',
                Deleting:'Deleting',
                Creating:'Creating',
                Modify:'Modify',
              },
            },
            add:{
              title:'Create Primary/secondary Server Group',
              desc:'The current load balancing network type is a classic network and the instance type is a private network. You can add cloud servers of classic network or VPC type to the active and master-slave group.',
              name:'Primary/secondary Server Group Name',
              add:'Add',
              save:'Save',
            },
            detail:{
              title:'Primary/secondary Server Group Detail',
              name:'Primary/secondary Server Group Name',
              cancel:'Cancel',
            },
            delete:{
              title:'Delete primary/secondary Server Group',
              tip:'Sure to delete the primary/secondary server group?',
              name:'Name:',
              cancel:'Cancel',
              delete:'Delete',
            },
            error:{
              port:'Please fill in the port',
              portSame:'The two ports cannot be the same',
              select:'Only 2 can be selected',
            },
          },
        }
      }
    },
    cerManage:{
      search:'Search',
      searchTip:'Search Certificate',
      add:'New Certificate1',
      list:{
        name:'Certificate Name / ID',
        domain:'Certificate Domain',
        time:'Created at',
        expired:'Expired at',
        actions:'Actions',
        listen:'Associated Listening <br/>\n' +
          'Extended Domain',
        delete:'Delete',
      },
      reName:{
        title:'Rename Certificate',
        sure:'Sure to rename',
        name:'New Name:',
        nameTip:'Please enter a new Name here',
        nameDesc:'6-64 Characters',
        cancel:'Cancel',
        done:'Done',
      },
      delete:{
        title:'Delete Certificate',
        sure:'Sure to delete the certificate?',
        id:'Certificate Id:',
        domain:'Certificate Domain :',
        cancel:'Cancel',
        delete:'Delete',
      },
    },
    policy:{
      search:'Search',
      searchTip:'Search Name',
      addTip:'Create Access Control Policy Group',
      add:{
        title:'Create Access Control Policy Group',
        desc:' <li>One line for each entry, separated by carriage returns.</li>\n' +
          '            <li>\n' +
          '              The address / address segment and remark of each entry are\n' +
          '              separated by "|", such as "192.168.1.0/24 | remark".\n' +
          '            </li>',
        name:'Name:',
        nameDesc:'The value contains 1 to 80 letters, digits, hyphens (-), slash (/), periods (.), underscores (_), and asterisks (*).',
        version:'IP Version:',
        add:'Mass Add:',
        addTip:'Format description:\n' +
          '1. One line per entry, separated by carriage returns.\n' +
          '2. The address/address block and remarks of each entry are separated by |, such as "192.168.1.0/24|remarks".',
        cancel:'Cancel',
        done:'Done',
      },
      list:{
        name:'Policy Group Name / ID',
        version:'IP Version',
        listen:'Associated Listening',
        actions:'Actions',
        delete:'Delete',
        manage:'Manage',
      },
      reName:{
        title:'Rename Policy Group',
        sure:'Sure to rename',
        name:'New Name:',
        nameTip:'Please enter a new Name here',
        nameDesc:'6-64 Characters',
        cancel:'Cancel',
        done:'Done',
      },
      delete:{
        title:'Delete Policy Group',
        sure:'Sure to delete the policy grou',
        sureTip:'Caution: It cannot be restored once deleted.',
        cancel:'Cancel',
        delete:'Delete',
      },
      manage:{
        title:'Manage Policy Group',
        add:'Mass Add',
        addTip:'1. One line for each entry, separated by carriage returns.\n' +
          '2. The address / address segment and remark of each entry are separated by \'|\', such as \'192.168.1.0/24 | remark\'.',
        delete:'Mass Delete',
        cancel:'Cancel',
        save:'Save',
        del:'Del',
        list:{
          id:'ID',
          address:'IP Address (Segment)',
          remark:'Remark',
          actions:'Actions',
        },
        deletePage:{
          title:'Delete Entry',
          sure:'Sure to delete the entry ?',
          address:'address (field):',
          remark:'Remark:',
          delete:'Delete',
          cancel:'Cancel',
        },
        massDel:{
          title:'Delete Entries',
          sure:'Sure to delete the entries?',
          cancel:'Cancel',
          delete:'Delete',
        },
      },
      error:{
        line:'Please make sure that each row are segment( | note)',
      }
    },
    renew:{
      title:'Renew',
      desc:'Current Configuration of Instance',
      summary:'Summary',
      cpu:'CPU',
      cores:'Cores',
      core:'Core',
      bandwidth:'Mbps Bandwidth',
      ram:'GB Memory',
      address:'IP Address',
      duration:'Duration:',
      durationList:[
        {
          label: "1 Month",
          value: 1,
        },
        {
          label: "2 Months",
          value: 2,
        },
        {
          label: "3 Months",
          value: 3,
        },
        {
          label: "6 Months",
          value: 6,
        },
        {
          label: "1 Year",
          value: 12,
        },
        {
          label: "2 Years",
          value: 24,
        },
      ],
      price:'Price: ',
      cancel:'Cancel',
      pay:'Pay',
      copySuccess:'Copied to clipboard.',
      copyFail:'Copy fail.',
      copy:'Copy',
    },
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/elb.js